<!-- Migas de pan (ui-redesign). Estilos .crumbs en design-system (.ds). -->
<div class="ds" *ngIf="trail.length">
	<div class="wrap">
		<nav class="crumbs">
			<a class="cb" (click)="router.navigate(['/home'])" aria-label="Inicio">
				<span class="ic"><mat-icon>home</mat-icon></span>
			</a>
			<ng-container *ngFor="let item of trail; let last = last">
				<a *ngIf="!last" (click)="go(item)" style="cursor: pointer">{{ item.raw ? item.label : (item.label | translate) }}</a>
				<span *ngIf="last" class="cur">{{ item.raw ? item.label : (item.label | translate) }}</span>
				<span *ngIf="!last" class="sep">/</span>
			</ng-container>
		</nav>
	</div>
</div>
